export const ShipstationPalette = {
  id: 'shipstation-default',
  app: 'shipstation',
  name: 'ShipStation Palette',

  buttonClasses: {
    primary: 'button-primary',
    secondary: 'button-secondary',
    danger: 'button-danger',
    unstyled: 'button-unstyled',
    white: 'button-white',
    'white-outlined': 'button-white-outlined',
    'white-outlined-pine': 'button-white-outlined-pine',
    'pine-text-on-white': 'button-pine-text-on-white',
    promotional: 'button-promotional',
    tertiary: 'button-tertiary',
    upsell: 'button-upsell',
    marketing: 'button-marketing',
  },

  pillClasses: {
    planned: 'planned-status-theme',
    completed: 'completed-status-theme',
    onHold: 'on-hold-status-theme',
    inProgress: 'in-progress-status-theme',
    '': 'pill',
  },
};
